import { render, staticRenderFns } from "./companies-add-or-update.vue?vue&type=template&id=1e2af8d8&scoped=true&"
import script from "./companies-add-or-update.vue?vue&type=script&lang=js&"
export * from "./companies-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./companies-add-or-update.vue?vue&type=style&index=0&id=1e2af8d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2af8d8",
  null
  
)

export default component.exports